/**
 * Primary tournament brand name used throughout the website.
 */
export const EVENT_NAME = 'The Prophet Games'

/**
 * Full product title used for the browser tab and footer.
 */
export const APP_TITLE = `${EVENT_NAME} Manager`

/**
 * Short brand line used in the shared layout chrome.
 */
export const BRAND_TAGLINE = 'Prophecy, fire, and Tecmo glory.'

/**
 * Dashboard hero copy that frames the event atmosphere.
 */
export const HERO_DESCRIPTION =
  'The omen-lit home for standings, uploads, stats, and every showdown on the path to glory.'
